import React, { useState, useEffect } from 'react';
import { TRANSACTION_RECORD_TYPE } from '../../containers/record/records/TransactionList';
import offlineWaterFillingImage from '../../assets/images/transaction/offlineWaterFilling.svg';
import offlinePhotoTakingImage from '../../assets/images/earning/photoTaking.png';
import offlineGreenDiningImage from '../../assets/images/transaction/offlineGreenDining.svg';
import offlineAdminCreateImage from '../../assets/images/transaction/offlineAdminCreate.svg';
import ContentSections from '../base/ContentSections';
import { OnlyContinueButton } from '../base/BottomStepComponent';
import { useDispatch, useSelector } from 'react-redux';
import { createAction } from '../../utils';
import { useHistory } from 'react-router-dom';
import { APIStatus } from '../../config/CustomEnums';
import Loading from '../base/Loading';
import ItemTypeSet, { MIN_WIDTH, SPACE_BETWEEN } from '../base/ItemTypeSet';
import { getScrollbarWidth, useMainContentWidth } from '../../utils/ScreenUtil';
import { defaultStep } from '../../models/StepBarUtil';
import { adminCreateStepNameList, stepNameList } from '../../models/CreateTransactionModel';

function CreateTransactionStepOne() {
  const queryString = require('query-string');
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedType, setSelectedType] = useState();
  const [showRedirectPrompt, setShowRedirectPrompt] = useState(false);

  const { defaultSelectedType, status, stepConfig } = useSelector((state) => ({
    defaultSelectedType:
      state.createTransaction.transaction.transactionDisplayType,
    status: state.loading.status,
    stepConfig: state.createTransaction.stepConfig,
  }));

  useEffect(() => {
    if (defaultSelectedType !== selectedType) {
      setSelectedType(defaultSelectedType);
    }
  }, [defaultSelectedType, selectedType]);

  useEffect(() => {
    if (defaultSelectedType === TRANSACTION_RECORD_TYPE.TYPE_ADMIN_CREATE && stepConfig?.length !== 4) {
      dispatch(
        createAction('createTransaction/updateState')({
          stepConfig: defaultStep(adminCreateStepNameList)
        }),
      );
      return;
    }
    if (defaultSelectedType !== TRANSACTION_RECORD_TYPE.TYPE_ADMIN_CREATE && stepConfig?.length === 4) {
      dispatch(
        createAction('createTransaction/updateState')({
          stepConfig: defaultStep(stepNameList)
        }),
      );
      return;
    }
  }, [defaultSelectedType, stepConfig?.length]);

  const transactionTypeList = [
    // {
    //   id: TRANSACTION_RECORD_TYPE.TYPE_ONLINE,
    //   title: 'Online',
    //   description: 'Online shopify transaction',
    //   image: OnlineImage,
    // },
    // {
    //   id: TRANSACTION_RECORD_TYPE.TYPE_OFFLINE_POS,
    //   title: 'Offline POS',
    //   description: 'Physical store transaction',
    //   image: OfflinePOSImage,
    // },
    {
      id: TRANSACTION_RECORD_TYPE.TYPE_PHOTO_TAKING,
      title: 'Photo taking',
      description: 'Recycling transaction',
      image: offlinePhotoTakingImage,
    },
    {
      id: TRANSACTION_RECORD_TYPE.TYPE_QR_CODE_SCANNING,
      title: 'Water filling',
      description: 'Water filling transaction',
      image: offlineWaterFillingImage,
    },
    {
      id: TRANSACTION_RECORD_TYPE.TYPE_OFFLINE_REWARD_CLAIM,
      title: 'General purchase',
      description: 'General purchase transaction',
      image: offlineGreenDiningImage,
    },
    {
      id: TRANSACTION_RECORD_TYPE.TYPE_ADMIN_CREATE,
      title: 'Admin create transaction',
      description: 'Add Carbon Savings / CW Point(s) to customers',
      image: offlineAdminCreateImage,
    },
  ];
  const mainContentWidth = useMainContentWidth();
  const fullContainerWith = mainContentWidth - 80 - 60 - getScrollbarWidth();
  console.log('@@59: ', fullContainerWith);
  const sections = [
    status === APIStatus.calling ? (
      <Loading />
    ) : (
      <div className="create-point-step-one-title">
        <label className="step-one-title">Transaction Type</label>
        <div
          className="point-record-step-type-area transaction-step-type-area"
          style={{
            justifyContent:
              fullContainerWith < (MIN_WIDTH + SPACE_BETWEEN) * 2 ||
              transactionTypeList.length < 3
                ? 'center'
                : 'flex-start',
          }}
        >
          {transactionTypeList.map((item, index) => {
            return (
              <ItemTypeSet
                key={index}
                item={item}
                selected={selectedType}
                onClick={(id) => {
                  setSelectedType(id);
                  dispatch(
                    createAction('createTransaction/updateTransactionType')({
                      type: id,
                    }),
                  );
                }}
              />
            );
          })}
        </div>
      </div>
    ),
  ];

  return (
    <>
      <ContentSections sections={sections} hidePreview={true} />
      <OnlyContinueButton
        continueAction={() => {
          if (selectedType === TRANSACTION_RECORD_TYPE.TYPE_ONLINE) {
            setShowRedirectPrompt(true);
          } else {
            dispatch(createAction('createTransaction/stepChange')({ step: 0 }));
          }
        }}
        disabledContinue={!selectedType}
      />
    </>
  );
}

export default CreateTransactionStepOne;
